import React, { useState } from "react";
import CancelIcon from "@material-ui/icons/Cancel";
import Spinner from "../../../presentation/spinner";
import useZoneSelectorController from "./useZoneSelectorController";
import "./style.css";

export default ({ projectId, onSelectZone }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [activeSuggestion, setActiveSuggestion] = useState(null);
  const {
    loadingZones,
    zones,
    textValue,
    onTextChange,
    onSelectOption,
    hasMorePages,
    requestNextPage,
    selectedZone,
  } = useZoneSelectorController(projectId, onSelectZone);

  // Event fired when the user presses a key down
  const onKeyDown = (e) => {
    // User pressed the enter key, update the input and close the
    // suggestions
    if (e.keyCode === 13 && activeSuggestion !== null) {
      e.preventDefault();
      onSelectOption(zones[activeSuggestion]);
      onSelectZone(zones[activeSuggestion]);
      setActiveSuggestion(null);
    }

    // User pressed the up arrow, decrement the index
    else if (e.keyCode === 38 && showDropdown) {
      e.preventDefault();
      if (activeSuggestion === 0 || activeSuggestion === null) {
        return;
      }

      setActiveSuggestion((activeSuggestionValue) => activeSuggestionValue - 1);
    }
    // User pressed the down arrow, increment the index
    else if (e.keyCode === 40 && showDropdown) {
      e.preventDefault();
      if (activeSuggestion === null) {
        setActiveSuggestion(0);
        return;
      }

      if (activeSuggestion === zones.length - 1) {
        return;
      }

      setActiveSuggestion((activeSuggestionValue) => activeSuggestionValue + 1);
    }
  };

  const handleScroll = (scrollEvent) => {
    if (hasMorePages && !loadingZones) {
      const SCROLL_BOTTOM_OFFSET = 100;
      const scrollTarget = scrollEvent.target;
      const hasReachedBottom =
        scrollTarget.scrollHeight - scrollTarget.scrollTop <=
        scrollTarget.clientHeight + SCROLL_BOTTOM_OFFSET;
      if (hasReachedBottom) {
        requestNextPage();
      }
    }
  };

  const renderDropdownItems = () => {
    if (loadingZones && zones.length === 0) {
      return (
        <Spinner
          overrideDefaultPosition
          position="relative"
          marginTop={0.1}
          padding="4rem 0"
        />
      );
    }
    if (!projectId) {
      return <div className="list-message">Please select a project</div>;
    }
    if (zones.length === 0 && !textValue) {
      return (
        <div className="list-message">No zones found for this project</div>
      );
    }
    if (zones.length === 0) {
      return <div className="list-message">No zones match the search term</div>;
    }
    const dropdownOptions = zones.map((option, index) => {
      const className =
        index === activeSuggestion ? "list-item active" : "list-item";
      return (
        <div
          key={option._id}
          className={className}
          onMouseDown={() => {
            setActiveSuggestion(null);
            onSelectOption(zones[index]);
            onSelectZone(zones[index]);
          }}
        >
          {option.name}
        </div>
      );
    });

    if (!hasMorePages) {
      return dropdownOptions;
    }

    return dropdownOptions.concat(
      <div className="list-message">
        <Spinner
          overrideDefaultPosition
          position="relative"
          marginTop={0.1}
          padding="1rem 0"
        />
      </div>
    );
  };

  return (
    <div className="input-wrapper">
      <label className="input-label" htmlFor="codeInput">
        Zone:
      </label>
      <div className="autocomplete-input-wrapper">
        <input
          type="text"
          id="zoneInput"
          className="search-input"
          placeholder="Search by name, destination ID, or Zone ID"
          onFocus={() => setShowDropdown(true)}
          onBlur={() => {
            setShowDropdown(false);
            setActiveSuggestion(null);
          }}
          onChange={(event) => {
            onTextChange(event);
            onSelectOption(undefined);
          }}
          onKeyDown={onKeyDown}
          value={selectedZone ? selectedZone.name : textValue}
          autoComplete="off"
        />
        {textValue || selectedZone ? (
          <CancelIcon
            onClick={() => {
              setActiveSuggestion(null);
              const clearTextEvent = {
                target: {
                  value: "",
                },
              };
              onTextChange(clearTextEvent);
              onSelectOption(null);
              onSelectZone(null);
            }}
            className="simulations-cancel-icon"
          />
        ) : undefined}
        {showDropdown && (
          <div className="suggestions-dropdown-wrapper" onScroll={handleScroll}>
            {renderDropdownItems()}
          </div>
        )}
      </div>
    </div>
  );
};
